import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY

export const getExtraction = async (startDate, endDate, idOp, group) => {
    const start = startDate.toISOString().split('T')[0];
    const end = endDate.toISOString().split('T')[0];
    try {
        const data = { start, end, idOp, group }
        const result = await api.post(`${urlApi}/administracion/gasoline/getExtractionData`, data);
        return result.data;
    } catch (e) {
        console.log(e);
    }
}
